import { styled as t } from "styled-components";
import { SmartLink as n } from "../../../components/SmartLink/index.js";
import { MediaQuery as i } from "../../../styles/variables.js";
import { Caption as r, CaptionHeavy as e } from "../../../styles/typography/index.js";
import { DealStamp as a } from "../../Deal/DealStamp/index.js";
import { Colors as l } from "../../../styles/colors/index.js";
import { Theme as o } from "../../../styles/themes/index.js";
import { Icon as s } from "../../../components/Icon/index.js";
const y = t.li`
  list-style: none;
`, C = t(n)`
  display: contents;
`, u = t.div`
  display: flex;
  padding: 12px 16px;
  margin-bottom: 1px;
  text-decoration: none;
  background-color: var(--backgroundColor);
  text-align: left;
`, $ = t.div`
  height: 64px;
  flex: 0 0 64px;
  margin-right: 8px;
  border: 1px solid rgb(${o.colors.Golf});
  border-radius: 4px;
  background-color: rgb(${o.colors.Juliet});
`, h = t.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`, v = t.div`
  ${r}
  width: 100%;
  color: rgb(${o.colors.Alpha});
`, k = t.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  @media ${i.SCREEN_MD_UP} {
    flex-direction: row;
    justify-content: space-between;
    margin-top: 8px;
    align-items: center;
  }
`, w = t.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`, I = t.div`
  ${e}
  display: flex;
  align-items: center;
`, S = t(a)`
  margin-left: 4px;
  ${e}
  color: rgb(${o.colors.Alpha});
  small {
    ${e}
  }
`, j = t.time`
  color: rgb(${l.Gray});
`, D = t(s)`
  font-size: 18px;
  color: rgb(${o.colors.Brand});
`, T = t.button`
  display: contents;
`;
export {
  D as ClickableItem,
  y as Container,
  u as Content,
  I as DealInfos,
  h as Image,
  $ as ImageContainer,
  k as InfosContainer,
  S as NotificationDealStamp,
  T as StyledButton,
  C as StyledLink,
  v as TextContainer,
  j as Timestamp,
  w as TitleContainer
};
